var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"40","height":"4","viewBox":"0 0 40 4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"40","height":"4","rx":"2","fill":"black","fill-opacity":"0.2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }